import { get, post } from '../../utils/http';

export const addOrder = ({
  accountId,
  branchId,
  supplierBranchId,
  supplierBookerId,
  comments,
  uniformId,
  instructions,
  meetingSpot,
  onsiteContactName,
  onsiteContactPhone,
  isDraft,
  shifts,
  date,
  endDate,
  locationId,
  name,
  clientBranchId,
  clientAdminid,
  applicationType,
  poNumber,
  selfServeMethod
}) =>
  post(`/accounts/${accountId}/branches/${branchId}/orders`, {
    supplierBranchId,
    supplierBookerId,
    comments,
    uniformId,
    instructions,
    meetingSpot,
    onsiteContactName,
    onsiteContactPhone,
    isDraft,
    shifts,
    date,
    endDate,
    clientBranchId,
    clientAdminid,
    locationId,
    name,
    applicationType,
    poNumber,
    selfServeMethod
  });

export const fetchBranchOrders = ({ accountId, branchId }) => get(`/accounts/${accountId}/branches/${branchId}/orders`);

export const fetchSupplierBranchOrderStats = ({ accountId, branchId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/orders/stats`);
